import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle, AiOutlineMenu } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { UserContext } from '../context/UserContext';
import { MenuContext } from '../context/MenuContext';
import { Button } from '@chakra-ui/react';
import user_image from '../images/Sample_User_Icon.png';

export function TopBar() {
  const { userProfile } = useContext(UserContext);
  const { menuOpen, setMenuOpen } = useContext(MenuContext)
  const navigate = useNavigate();

  return (
        <div className="flex justify-between items-center mb-6">
            <h2 className="hidden lg:block text-md lg:text-xl font-semibold">Welcome {userProfile?.name}!</h2>
            <div
                onClick={() => {setMenuOpen(true); console.log(menuOpen)}}
                className="flex cursor-pointer items-center justify-center lg:hidden"
            >
                <AiOutlineMenu size={20} />
                <h2 className="ml-3 block lg:hidden text-md lg:text-xl font-semibold">Menu</h2>
            </div>
            <div className="flex items-center space-x-4">
                <div className="hidden lg:flex items-center bg-white px-4 py-2 w-auto text-sm text-dark font-semibold">
                    {/* <FaSearch className="text-gray-400" />
                    <input
                        type="text"
                        placeholder="Find anything here"
                        className="ml-2 outline-none bg-transparent w-full text-sm"
                    /> */}
                    Timezone: {userProfile?.user_timezone}
                </div>
                {/* <div className="relative">
                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full"></span>
                    <svg className="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M15 17h5l-1.405-1.405M21 17v-2a9.003 9.003 0 00-7-8.714V6a3 3 0 00-6 0v.286A9.003 9.003 0 003 15v2l-1.405 1.405A1 1 0 003 20h18a1 1 0 00.707-1.707L21 17z" />
                    </svg>
                </div> */}
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-blue-200 overflow-hidden">
                    <img src={user_image} className="h-6" alt="user" />
                </div>
                <div onClick={() => navigate('/manage-child')} className='hidden lg:flex flex-col cursor-pointer justify-start items-start'>
                    <a className='text-xs text-dark font-semibold'>{userProfile?.sub_name != null ? 'Showing:' + userProfile?.sub_name : 'No Child Created'}</a>
                    <a className='text-xs text-dark'>Switch Account</a>
                </div>
                <div onClick={() => navigate('/manage-child')} className='flex lg:hidden flex-col cursor-pointer justify-start items-start'>
                    <a className='text-xs text-dark font-semibold'>{userProfile?.sub_name != null ? 'Showing:' + userProfile?.sub_name : 'No Child Created'}</a>
                    <a className='text-xs text-dark'>Switch</a>
                </div>
            </div>
        </div>
    )
}
